/**
 * Compact relative-time formatter — "just now" / "Xm ago" / "Xh ago" /
 * "Xd ago", falling back to a short ISO date (matching the app's existing
 * `.slice(0, 10)` date convention) once an item is a week or older.
 * Used by the notification inbox row timestamps.
 */
export function formatRelativeTime(iso: string, now: Date = new Date()): string {
  const thenMs = new Date(iso).getTime();
  const nowMs = now.getTime();
  const diffMs = nowMs - thenMs;
  if (!Number.isFinite(diffMs)) return iso;

  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return 'just now';

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;

  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `${diffHour}h ago`;

  const diffDay = Math.floor(diffHour / 24);
  if (diffDay < 7) return `${diffDay}d ago`;

  return iso.slice(0, 10);
}
